import { BottomSheetHeader } from "@src/appV2/redesign/components/BottomSheetHeader";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";
import {
  BottomSheet,
  BottomSheetIllustrationContent,
  type UseModalState,
} from "@src/appV2/redesign/system/ui-components";

interface WorkerGeolocationMissingBottomSheetProps {
  modalState: UseModalState;
  onCancel: () => void;
  onClickUpdate: () => void;
}

export function WorkerGeolocationMissingBottomSheet(
  props: WorkerGeolocationMissingBottomSheetProps
) {
  const { modalState, onCancel, onClickUpdate } = props;

  return (
    <BottomSheet
      modalState={modalState}
      header={
        <BottomSheetHeader
          onClose={() => {
            modalState.closeModal();
          }}
        />
      }
      footer={
        <DialogFooter orientation="vertical" sx={{ marginTop: 5, marginBottom: 5 }}>
          <Button fullWidth variant="contained" size="large" onClick={onClickUpdate}>
            Update Address
          </Button>
          <Button fullWidth variant="outlined" size="large" onClick={onCancel}>
            Not now
          </Button>
        </DialogFooter>
      }
    >
      <BottomSheetIllustrationContent
        illustrationType="location-error"
        title="Missing address"
        description="To see shifts near you, please update your address in your profile."
      />
    </BottomSheet>
  );
}
